<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="locales.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/area";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["locales"],
              hideLabelFields: ["locales"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: ["sequence"],
            },
          ],
        },
      ],
    },
  }),
};
</script>